import OrgScopedPage from "./OrgScopedPage";
import IntentDashboard from "../IntentManager/IntentManager";

/**
 * PlatformIntents — super-admin Intents page. Reuses the exact tenant Intent
 * Manager (Intents / Categories / Domains) scoped to the selected organization.
 */
export default function PlatformIntents() {
    return (
        <OrgScopedPage title="Intents" subtitle="Manage an organization's intents, categories and domains.">
            <IntentDashboard />
        </OrgScopedPage>
    );
}
